import BalanceHour from "app/models/balanceHour"

export enum Types {
  GET = "BALANCE_HOURS_GET",
  GET_SUCCESS = "BALANCE_HOURS_GET_SUCCESS",
  GET_FAIL = "BALANCE_HOURS_GET_FAIL",
  GET_ESTIMATED = "ESTIMATED_BALANCE_HOURS_GET",
  GET_ESTIMATED_SUCCESS = "ESTIMATED_BALANCE_HOURS_GET_SUCCESS",
  GET_ESTIMATED_FAIL = "ESTIMATED_BALANCE_HOURS_GET_FAIL",
}

export type Action =
  | GetBalanceHoursAction
  | GetBalanceHoursSuccessAction
  | GetBalanceHoursFailAction
  | GetEstimatedBalanceHoursAction
  | GetEstimatedBalanceHoursSuccessAction
  | GetEstimatedBalanceHoursFailAction

export type GetBalanceHoursAction = {
  payload: { id: string; params: { weekId?: number; comparison?: string; limit?: number } }
  type: Types.GET
}

export type GetBalanceHoursSuccessAction = {
  payload: { data: BalanceHour[] }
  type: Types.GET_SUCCESS
}

export type GetBalanceHoursFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getBalanceHours(id: string, params: object): GetBalanceHoursAction {
  return {
    payload: { id, params },
    type: Types.GET,
  }
}

export function getBalanceHoursSuccess(data: BalanceHour[]): GetBalanceHoursSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getBalanceHoursFail(errors: object): GetBalanceHoursFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export type GetEstimatedBalanceHoursAction = {
  payload: { id: string; params: { weekId?: number; comparison?: string; limit?: number } }
  type: Types.GET_ESTIMATED
}

export type GetEstimatedBalanceHoursSuccessAction = {
  payload: { estimatedData: BalanceHour[] }
  type: Types.GET_ESTIMATED_SUCCESS
}

export type GetEstimatedBalanceHoursFailAction = {
  payload: { errors: object }
  type: Types.GET_ESTIMATED_FAIL
}

export function getEstimatedBalanceHours(id: string, params: object): GetEstimatedBalanceHoursAction {
  return {
    payload: { id, params },
    type: Types.GET_ESTIMATED,
  }
}

export function getEstimatedBalanceHoursSuccess(estimatedData: BalanceHour[]): GetEstimatedBalanceHoursSuccessAction {
  return {
    payload: { estimatedData },
    type: Types.GET_ESTIMATED_SUCCESS,
  }
}

export function getEstimatedBalanceHoursFail(errors: object): GetEstimatedBalanceHoursFailAction {
  return {
    payload: { errors },
    type: Types.GET_ESTIMATED_FAIL,
  }
}
